import { render, staticRenderFns } from "./bookingrecord.vue?vue&type=template&id=572ff1de&scoped=true&"
import script from "./bookingrecord.vue?vue&type=script&lang=js&"
export * from "./bookingrecord.vue?vue&type=script&lang=js&"
import style0 from "./bookingrecord.vue?vue&type=style&index=0&id=572ff1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ff1de",
  null
  
)

export default component.exports